<template>
  <main class="border-to-navi">
    <!-- Search Tabs -->
    <section id="search" class="search">
      <keep-alive>
        <SearchTabs />
      </keep-alive>
    </section>
    <section class="section content-container">
      <template v-if="error.statusCode === 404 || error.statusCode === 410">
        <img
          :src="`/assets/images/${error.statusCode}.svg`"
          :alt="`${error.statusCode} Image`"
          class="error-image"
        />
        <h1 class="title">
          {{ $t(`errorHandling.${error.statusCode}.title`) }}
        </h1>
        <p class="subtitle">
          {{ $t(`errorHandling.${error.statusCode}.description`) }}
        </p>
      </template>
      <template v-else>
        <h1 class="title">An error occurred</h1>
        <p v-if="error.message">
          <b>{{ error.message }}</b>
        </p>
      </template>
      <p class="subtitle">
        <nuxt-link class="hg-text-link link" :to="localePath('/')">
          {{ $t('backToHome') }}
        </nuxt-link>
      </p>
    </section>
    <section v-if="error.relatedDeals && error.relatedDeals.length">
      <!-- Related Deals -->
      <RelatedDealsSection :deals="error.relatedDeals" />
    </section>
  </main>
</template>

<script>
export default {
  components: {
    SearchTabs: () => import('@/components/search/SearchTabs'),
    RelatedDealsSection: () =>
      import('@/components/sections/RelatedDealsSection'),
  },
  props: {
    error: {
      type: Object,
      default: () => {
        return { statusCode: 404 };
      },
    },
  },
};
</script>

<style scoped>
.section {
  max-width: 930px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.error-image {
  max-width: 565px;
  margin-bottom: 2rem;
}
</style>
